<template>
  <div>
    <!-- INICIO FORMULARIO -->
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formSituacao.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome do Status"
            id="Nome do Status"
            v-model="formSituacao.nomeStatus"
            v-validate="{ required: true }"
            :state="
              validateState(this.veeFields, this.veeErrors, 'Nome do Status')
            "
            :class="
              validateClass(this.veeFields, this.veeErrors, 'Nome do Status')
            "
          />
        </div>
      </div>
      <div class="vx-col w-full">
        <span>Cor do Status</span>
        <div class="input-group-color">
          <input
            type="color"
            size="large"
            class="w-full color-picker"
            name="Cor do Status"
            id="Cor do Status"
            v-model="formSituacao.corStatus"
            v-validate="{ required: true }"
            :state="
              validateState(this.veeFields, this.veeErrors, 'Cor do Status')
            "
            :class="
              validateClass(this.veeFields, this.veeErrors, 'Cor do Status')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
          <vs-input
            class="w-full"
            name="Descrição da Cor"
            id="Descrição da Cor"
            v-model="formSituacao.corStatus"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
            disabled
          />
        </div>
      </div>
      <!-- INICIO ALERT -->
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <!-- FIM ALERT -->
      <!-- INICIO BOTÕES -->
      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="dados.idStatus ? true : false"
            :aguarde="aguardeCadastro"
            reference="BtnEditar"
          ></BotaoSubmit>
        </div>
      </div>
      <!-- FIM BOTÕES -->
    </form>
    <!-- FIM FORMULARIO -->
  </div>
</template>
<script>
import BotaoSubmit from '../../../../components/BotaoSubmit';
import locale from '../../../../locale.js';
import notify from '../../../../utils/notify.js';
import utils from '../../../../utils/list/';
import utilslocal from '../utils/';

export default {
  components: {
    BotaoSubmit,
  },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      formSituacao: {
        idStatus: null,
        status: false,
        nomeStatus: '',
        corStatus: null,
      },
      validateClass: utils.validateStateClass,
      validateState: utils.validateState,
    };
  },
  watch: {
    dados() {
      this.preencheForm(this.dados);
    },
  },
  methods: {
    preencheForm(dados) {
      const situacao = this.verificaSituacao(dados);
      if (situacao) {
        this.formSituacao = {
          idStatus: dados.idStatus,
          status: dados.deletedAt ? false : true,
          nomeStatus: dados.nomeStatus,
          corStatus: dados.corStatus,
        };
      } else {
        this.formSituacao = {
          idStatus: null,
          status: true,
          nomeStatus: '',
          corStatus: null,
        };
      }
    },
    verificaSituacao(dados) {
      return (
        'idStatus' in dados && 'nomeStatus' in dados && 'corStatus' in dados
      );
    },
    async onSubmit() {
      const formValidado = await this.$validator.validateAll();
      if (formValidado) {
        try {
          this.$vs.loading();

          if (this.formSituacao.idStatus) {
            await utilslocal.atualizarSituacoes([
              this.converterAtivacao(this.formSituacao),
            ]);
          } else {
            await utilslocal.criarSituacoes(
              this.converterAtivacao(this.formSituacao),
            );
          }

          this.resetForm();
          notify.notifySuccess(this.$vs, 'Operação realizada com sucesso');
          this.$emit('concluido');
        } catch (error) {
          notify.notifyFail(this.$vs, error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    converterAtivacao(situacao) {
      return { ...situacao, deletedAt: situacao.status ? null : new Date() };
    },
    onReset(evt) {
      evt.preventDefault();
      this.resetForm();
      this.$nextTick(() => {
        this.show = true;
      });
      this.$emit('cancel');
    },
    resetForm() {
      this.formSituacao = {
        idStatus: null,
        status: false,
        nomeStatus: '',
        corStatus: null,
      };
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
  },
};
</script>
<style>
.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
